import { retrieveBooks } from "../../../books/actions";

const loadBooks = () => {
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books");
    const books = await response.json();

    dispatch(retrieveBooks(books));
  };
};

export default loadBooks;
